import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { useSocket } from '@/lib/socket';
import { Badge, Button } from './ui';

const LINKS = [
  { to: '/', label: 'Salon', exact: true },
  { to: '/classement', label: 'Classement' },
  { to: '/historique', label: 'Historique' },
];

export function Layout() {
  const { user, logout } = useAuth();
  const { connected } = useSocket();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate('/connexion');
  }

  return (
    <div className="flex min-h-full flex-col">
      <header className="border-b border-slate-800/80 bg-slate-950/70 backdrop-blur">
        <div className="mx-auto flex w-full max-w-6xl flex-wrap items-center gap-4 px-4 py-3">
          <NavLink to="/" className="flex items-center gap-2 text-lg font-bold text-sky-300">
            <span aria-hidden>⚓</span>
            <span>Flotte</span>
          </NavLink>

          <nav className="flex flex-1 flex-wrap items-center gap-1">
            {LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.exact}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-1.5 text-sm font-medium transition ${
                    isActive
                      ? 'bg-slate-800 text-sky-300'
                      : 'text-slate-300 hover:bg-slate-800/60'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            {user?.role === 'admin' && (
              <NavLink
                to="/admin"
                className={({ isActive }) =>
                  `rounded-lg px-3 py-1.5 text-sm font-medium transition ${
                    isActive
                      ? 'bg-amber-500/20 text-amber-300'
                      : 'text-amber-300/80 hover:bg-amber-500/10'
                  }`
                }
              >
                Administration
              </NavLink>
            )}
          </nav>

          <div className="flex items-center gap-3">
            <Badge tone={connected ? 'succes' : 'alerte'}>
              {connected ? 'En ligne' : 'Hors ligne'}
            </Badge>
            <NavLink
              to="/compte"
              className="text-sm font-medium text-slate-200 hover:text-sky-300"
            >
              {user?.displayName}
            </NavLink>
            <Button variant="discret" onClick={() => void handleLogout()}>
              Déconnexion
            </Button>
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-6">
        <Outlet />
      </main>

      <footer className="px-4 py-4 text-center text-xs text-slate-500">
        Plateforme de jeux — serveur autoritaire, classement ELO.
      </footer>
    </div>
  );
}
